module.exports = __webpack_public_path__ + "img/skating001.998e18ef.jpg";